<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <span :class="['anna-score', `anna-tone--${tone}`]">{{ text }}</span>
</template>

<script>
import {scoreTone} from '../util/review';

// Card-table cell for one ANNA score. The column header sets `max` (100 or 10).
export default {
  name: 'AnnaScoreCell',
  props: {
    item: {
      type: Number,
      required: false,
      default: null,
    },
    header: {
      type: Object,
      required: true,
    },
  },
  computed: {
    max() {
      return this.header.max || 100;
    },
    tone() {
      return scoreTone(this.item, this.max);
    },
    text() {
      if (this.item === null || this.item === undefined) return '—';
      return this.max === 100 ? `${this.item}` : `${this.item}/${this.max}`;
    },
  },
};
</script>

<style lang="scss" scoped src="./anna-tones.scss"></style>
